var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardPatientImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 96,
    viewBox: "0 0 232 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 98,
    y: 1,
    width: 37,
    height: 46,
    rx: 18.5,
    fill: "white",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M97 23H103C106.866 23 110 19.866 110 16V15",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M135 23H117C113.134 23 110 19.866 110 16V8",
    stroke: "#009688",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    opacity: 0.2,
    d: "M109.5 16.5001H108.5V18.0001C108.5 19.4495 107.739 20.4841 106.463 21.2075C105.15 21.9514 103.354 22.3144 101.571 22.3144H98.4572V20.5716C98.4572 10.52 106.606 2.37158 116.657 2.37158C126.709 2.37158 134.857 10.52 134.857 20.5716V22.3144H119.4C115.155 22.3144 112.981 21.0648 111.855 19.8161C110.703 18.5392 110.5 17.1011 110.5 16.5001H109.5Z",
    fill: "#009688",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_80_807",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.125 52L115.5 64L127.875 52H129.5H135C143.837 52 151 59.1634 151 68V96H81V68C81 59.1634 88.1634 52 97 52H98.5H103.125Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.125 52L115.5 64L127.875 52H129.5H135C143.837 52 151 59.1634 151 68V96H81V68C81 59.1634 88.1634 52 97 52H98.5H103.125Z",
    fill: "#009688",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 64L114.108 65.4358L115.5 66.7859L116.892 65.4358L115.5 64ZM103.125 52L104.517 50.5642L103.935 50H103.125V52ZM127.875 52V50H127.065L126.483 50.5642L127.875 52ZM151 96V98H153V96H151ZM81 96H79V98H81V96ZM116.892 62.5642L104.517 50.5642L101.733 53.4358L114.108 65.4358L116.892 62.5642ZM126.483 50.5642L114.108 62.5642L116.892 65.4358L129.267 53.4358L126.483 50.5642ZM127.875 54H129.5V50H127.875V54ZM129.5 54H135V50H129.5V54ZM135 54C142.732 54 149 60.268 149 68H153C153 58.0589 144.941 50 135 50V54ZM149 68V96H153V68H149ZM151 94H81V98H151V94ZM83 96V68H79V96H83ZM83 68C83 60.268 89.268 54 97 54V50C87.0589 50 79 58.0589 79 68H83ZM97 54H98.5V50H97V54ZM98.5 54H103.125V50H98.5V54Z",
    fill: "#009688",
    mask: "url(#path-5-inside-1_80_807)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M127 72.5H140.5",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M115.5 64.5V79.5857",
    stroke: "#009688",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M0 95H232",
    stroke: "#009688",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPatientImg);
export default __webpack_public_path__ + "static/media/dashboardPatientImg.4b34b146c8f42fc07f05cf90294c53d9.svg";
export { ForwardRef as ReactComponent };